export default __webpack_public_path__ + "static/car8-f205c6a5588401541d503fec38ab2973.glb";